import { Link } from 'react-router-dom';
import './Header.css';
import logo from './Pics/LOGOO.png'
import { useState } from 'react';

let Header =()=>{ 
    let [time,settime]= useState(null);
    let gettime=()=>{
        let time = new Date();
        let timestring = time.toLocaleTimeString();
      
        settime(timestring);
    }
   setInterval(() => {
    gettime();
   }, 1000);
     
    
    return(
        <div className='Headermaincont'>
            <ul className='ulcont'>
                <li><Link to='/'>Home</Link></li>
                <li> <Link to='Services'>Services</Link> </li>
                <li> <Link to='Aboutus'>AboutUs</Link> </li>
                <li><Link to="Devloper-log-in-page">ForDevloper</Link></li>
                
            </ul> 
            <h1 className='easywayheadingcont'>
                <marquee behavior="" direction="right" className="marq"><span className='logo'>
                    <img className='logo' src={logo} alt='logo'/>
                </span></marquee>

                <span className='makeeasyway'>makeeasyway.in</span>
                <p id='timedisplay' className='any'>{time}</p>
            </h1>
        </div>
    );

}
export default Header;